import {EstadoDelAsistenteSchema, RespuestaDelAsistenteSchema, type PreguntaAlAsistente} from '@cnc/contracts';
import {useMutation, useQuery} from '@tanstack/react-query';
import {pedir} from './cliente';

// Asistente de ayuda sobre el uso de la plataforma.
export function useEstadoDelAsistente(activo: boolean) {
  return useQuery({
    queryKey: ['asistente', 'estado'],
    queryFn: () => pedir('asistente/estado', EstadoDelAsistenteSchema),
    enabled: activo,
    staleTime: 5 * 60_000,
  });
}

export function usePreguntarAlAsistente() {
  return useMutation({
    mutationFn: (pregunta: PreguntaAlAsistente) =>
      pedir('asistente/preguntar', RespuestaDelAsistenteSchema, {
        method: 'POST',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify(pregunta),
      }),
  });
}
